import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import AudioRecording from 'components/audio-recoder/AudioRecording';

/**
 * @component QuestionSpeaking
 * @description
 * Componente encargado de mostrar el campo de grabación de audio para la sección Speaking del examen.
 * Integra el componente `AudioRecording` que permite grabar, detener y regrabar audio,
 * y además expone el control de grabación a través de un `ref`.
 *
 * @param {Object} props
 * @param {Object} props.audioRef - Referencia para controlar la grabación desde el padre
 * @param {Function} props.onAudioComplete - Callback que recibe el archivo de audio (`File`) una vez finalizada la grabación
 *
 * @returns {JSX.Element}
 *
 * @example
 * <QuestionSpeaking
 *   audioRef={audioRef}
 *   onAudioComplete={(file) => console.log(file)}
 * />
 */
const QuestionSpeaking = ({ audioRef, onAudioComplete }) => (
	<Row className="mt-3 justify-content-center">
		<Col xl={8}>
			<Form.Group>
				<Form.Label>Record your answer</Form.Label>
				<AudioRecording ref={audioRef} onRecordingComplete={onAudioComplete} />
			</Form.Group>
		</Col>
	</Row>
);

export default QuestionSpeaking;